<div id="menu4" class="tab-pane ">
    <ul class="caldBtmIcon">
        <li><a href="#" class="fullscreenToggle"><i class="material-icons">fullscreen</i></a></li>
    </ul>
    <div class="attendTable">
        <div class="reportpanel mCustomScrollbar" data-mcs-theme="minimal-dark">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">
                                <p>Team Name</p>
                            </th>
                            <th scope="col">
                                <p>Team Members</p>
                            </th>
                            <th scope="col">
                                <p>Present Today</p>
                            </th>
                            <th scope="col">
                                <p>Admin Manager</p>
                            </th>
                            <th scope="col">
                                <p>Action</p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p><strong>UI/UX Design <span class="tcount">2</span></strong></p>
                            </td>
                            <td>
                                <ul class="nameList">
                                    <li>
                                        <a href="">
                                            <div class="peopleText lgreen">SM</div>
                                        </a>
                                    </li>
                                    <li>
                                        <div class="peopleText lorange">RK</div>
                                    </li>
                                    <li>
                                        <div class="peopleText pic"><img src="img/picImg01.png" alt=""
                                                class="mCS_img_loaded"></div>
                                    </li>
                                    <li>
                                        <div class="peopleText lpurple">AM</div>
                                    </li>
                                    <li>
                                        <div class="peopleText lgrey1">+ 2</div>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <p><span class="greenText">5</span>/6 <a href="#" class="infoIcon"><img
                                            src="img/infoIcon.png" alt=""></a></p>
                            </td>
                            <td>
                                <p>Vinay Verma</p>
                            </td>
                            <td>
                                <ul class="callActionList">
                                    <li><a href="#"><i class="material-icons-outlined">email</i>Mail</a></li>
                                    <li><a href="#"><i class="material-icons-outlined">video_camera_front</i>Meet</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>UI/UX Design <span class="tcount">2</span></strong></p>
                            </td>
                            <td>
                                <ul class="nameList">
                                    <li>
                                        <a href="" title="">
                                            <div class="peopleText lgreen">SM</div>
                                        </a>
                                    </li>
                                    <li>
                                        <div class="peopleText lorange">RK</div>
                                    </li>
                                    <li>
                                        <div class="peopleText pic"><img src="img/picImg01.png" alt=""
                                                class="mCS_img_loaded"></div>
                                    </li>
                                    <li>
                                        <div class="peopleText lpurple">AM</div>
                                    </li>
                                    <li>
                                        <div class="peopleText lgrey1">+ 2</div>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <p><span class="greenText">5</span>/6 <a href="#" class="infoIcon"><img
                                            src="img/infoIcon.png" alt=""></a></p>
                            </td>
                            <td>
                                <p>Vinay Verma</p>
                            </td>
                            <td>
                                <ul class="callActionList">
                                    <li><a href="#"><i class="material-icons-outlined">email</i>Mail</a></li>
                                    <li><a href="#"><i class="material-icons-outlined">video_camera_front</i>Meet</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>HR <span class="tcount">2</span></strong></p>
                            </td>
                            <td>
                                <ul class="nameList">
                                    <li>
                                        <a href="" title="">
                                            <div class="peopleText lgreen">SM</div>
                                        </a>
                                    </li>
                                    <li>
                                        <div class="peopleText lorange">RK</div>
                                    </li>
                                    <li>
                                        <div class="peopleText pic"><img src="img/picImg01.png" alt=""
                                                class="mCS_img_loaded"></div>
                                    </li>
                                    <li>
                                        <div class="peopleText lpurple">AM</div>
                                    </li>
                                    <li>
                                        <div class="peopleText lgrey1">+ 2</div>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <p><span class="greenText">5</span>/6 <a href="#" class="infoIcon"><img
                                            src="img/infoIcon.png" alt=""></a></p>
                            </td>
                            <td>
                                <p>Vinay Verma</p>
                            </td>
                            <td>
                                <ul class="callActionList">
                                    <li><a href="#"><i class="material-icons-outlined">email</i>Mail</a></li>
                                    <li><a href="#"><i class="material-icons-outlined">video_camera_front</i>Meet</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>Marketing <span class="tcount">5</span></strong></p>
                            </td>
                            <td>
                                <ul class="nameList">
                                    <li>
                                        <a href="" title="">
                                            <div class="peopleText lgreen">SM</div>
                                        </a>
                                    </li>
                                    <li>
                                        <div class="peopleText lorange">RK</div>
                                    </li>
                                    <li>
                                        <div class="peopleText pic"><img src="img/picImg01.png" alt=""
                                                class="mCS_img_loaded"></div>
                                    </li>
                                    <li>
                                        <div class="peopleText lpurple">AM</div>
                                    </li>
                                    <li>
                                        <div class="peopleText lgrey1">+ 2</div>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <p><span class="greenText">5</span>/6 <a href="#" class="infoIcon"><img
                                            src="img/infoIcon.png" alt=""></a></p>
                            </td>
                            <td>
                                <p>Vinay Verma</p>
                            </td>
                            <td>
                                <ul class="callActionList">
                                    <li><a href="#"><i class="material-icons-outlined">email</i>Mail</a></li>
                                    <li><a href="#"><i class="material-icons-outlined">video_camera_front</i>Meet</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>